import axios from '../utils/index';
import { Pat, HttpResponse } from '@/typings/request';
const dashboardApi = {
    async getDashboardInfo(params: Pat) {
        return axios.get(`/dashboard`, { params });
    },
    async getDashboardTotalMarketValue(params: Pat) {
        return axios.get(`/dashboard/total-market-value`, { params });
    },
    async getDashboardOnlineUders(params: Pat) {
        return axios.get(`/dashboard/online-user-line-chart`, { params });
    },
    async getDashboardNewUsers(params: Pat) {
        return axios.get(`/dashboard/new-user-line-chart`, { params });
    },
    async getDashboardTotalUsers(params: Pat) {
        return axios.get(`/dashboard/total-user-line-chart`, { params });
    },
    async dashboardExport(params: Pat) {
        return axios.get(`/dashboard/export/data`, { params });
    },
};

export default dashboardApi;
